import { Component, Input, Renderer, ElementRef } from '@angular/core';
import { PopoverEditableDropDownComponentBase } from '../../shared/components/popover-editable-dropdown.base.component';

import { IIdNameDescription } from '../../_entities';

@Component({
    selector: 'popover-editable-id-name-dropdown',
    template: require('./popover-editable-dropdown.base.template.html')
})
export class PopoverEditableIdNameDropdownComponent extends PopoverEditableDropDownComponentBase<number> {
    constructor(protected renderer: Renderer, protected element: ElementRef) {
        super(renderer, element);
    }

    dropdownItems: IIdNameDescription[];

    @Input() tuples: Promise<IIdNameDescription[]> | IIdNameDescription[];

    protected getItems(): Promise<number[]> {
        if (this.tuples instanceof Promise) {
            return this.tuples.then(result => {
                this.dropdownItems = result;
                return this.dropdownItems.map(r => r.id);
            });
        } else if (this.tuples != null) {
            this.dropdownItems = this.tuples;
            return Promise.resolve(this.dropdownItems.map(r => r.id));
        } else {
            return Promise.resolve(null);
        }

    }

    protected mapItem(items: number[], item: number): number {
        return items.find(x => x === item);
    }

    protected getValue(itemToFind: number): any {
        return itemToFind && this.dropdownItems ? this.dropdownItems.find(x => x.id === itemToFind) : null;
    }

    protected getDisplayValue(itemToFind: number) {

        const item = this.getValue(itemToFind);
        if (item) {
            return item.name;
        }
        if (itemToFind == null) {
            return null;
        }
        return itemToFind + "";

    }

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/popover-editable-id-name-dropdown.component.ts